import { Component } from "@angular/core";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  standalone: false,
})
export class ForgotPasswordComponent {}
